// Suppliers Actions
import Axios from 'axios'
import * as helpers from '@/mixins/helperFunctions.js'

// ***** Get suppliersList from backend then update suppliersList in vuex store ***** //
export const updateSuppliersList = async ({ commit }, payload = null) => {
  let params = {}

  if (payload) {
    params = {
      search: payload.search,
      page: payload.page,
      per_page: payload.rowsPerPage,
      column: payload.sortBy,
      sortDir: payload.descending ? 'desc' : 'asc',
      ...payload.advancedSearch
    }
  }

  try {
    const result = await Axios.get('venders_index', { params: params })
    commit('updateSuppliersList', result.data.data)
  } catch (error) {
    helpers.showErrorMessage(error, 'An error occurred, fetching list data failed')
  }
}

// ***** Fetch supplier from backend ***** //
export const fetchSupplierInfo = async ({ commit }, payload = null) => {
  if (!helpers.checkId(payload)) {
    throw new Error('Error')
  }

  // payload = 1000
  try {
    const result = await Axios.get(`venders_show/${payload}`)
    commit('fetchSupplierInfo', result.data.data)
  } catch (error) {
    helpers.showErrorMessage(error, 'An error occurred, fetching information failed')
  }
}

// ***** Add supplier ***** //
export const addSupplier = async (ignored, payload = null) => {
  try {
    await Axios.post('venders_store', payload)
    helpers.ktNotify({
      type: 'success',
      text: 'Added Successfully'
    })
  } catch (error) {
    helpers.showErrorMessage(error, 'An error occurred, creation failed')
  }
}

// ***** Update supplier info ***** //
export const updateSupplierInfo = async (ignored, payload = null) => {
  if (!helpers.checkId(payload.id)) {
    throw new Error('Error')
  }

  try {
    payload.formData.append('_method', 'PATCH')
    await Axios.post(`venders_update/${payload.id}`, payload.formData)
    helpers.ktNotify({
      type: 'success',
      text: 'Updated Successfully'
    })
  } catch (error) {
    helpers.showErrorMessage(error, 'An error occurred, update failed')
  }
}

// ***** Delete supplier ***** //
export const deleteSupplier = async (ignored, payload) => {
  if (!helpers.checkId(payload)) {
    throw new Error('Error')
  }

  try {
    await Axios.delete(`venders_destroy/${payload}`)
    helpers.ktNotify({
      type: 'success',
      text: 'Deleted Successfully'
    })
  } catch (error) {
    helpers.showErrorMessage(error, 'An error occurred, deletion failed')
  }
}

export const setFullVendersList = async ({ commit }) => {
  let vendersList = []

  try {
    const result = await Axios.get('venders_list')
    result.data.data.forEach(vender => {
      vendersList.push({ value: vender.vender_id, text: vender.vender_name })
    })
    commit('setFullVendersList', vendersList)
  } catch (error) {
    helpers.showErrorMessage(error, 'An error occurred, fetching list data failed')
  }
}
